export function resolveApiBase(endpoint, fallbackOrigin) {
    const base = (endpoint || fallbackOrigin).replace(/\/+$/, "");
    return /\/api$/.test(base) ? base : `${base}/api`;
}

export default resolveApiBase;
